import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MonthNumber, monthOptions } from './utilities/form';
import { catchError, exhaustMap } from 'rxjs/operators';
import { EMPTY, Subject, Subscription } from 'rxjs';

export type PoSignupSchemeItem = {
  description: string;
  information_url: string;
};

@Component({
  selector: 'app-po-category-sign-up-tool',
  templateUrl: './po-category-sign-up-tool.component.html',
  styleUrls: ['./po-category-sign-up-tool.component.scss'],
})
export class PoCategorySignUpToolComponent implements OnInit, OnDestroy {
  private readonly http = inject(HttpClient);

  private readonly lookup$ = new Subject<{month: number; year: number}>();

  private readonly subscriptions: Subscription[] = [];

  protected readonly yearOptions = Array.from({length: 11}, (_, index) => new Date().getFullYear() - index);
  protected readonly monthControl = new FormControl<MonthNumber | null>(null, Validators.required);
  protected readonly yearControl = new FormControl<number | null>(null, Validators.required);

  protected monthOptions = monthOptions;
  protected submitted = false;
  protected schemeItem: {description: string; informationUrl: string} | null | undefined =
    undefined;

  ngOnInit(): void {
    this.handleLookup();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  protected showMonthError() {
    return this.monthControl.invalid && (this.monthControl.touched || this.submitted);
  }

  protected showYearError() {
    return this.yearControl.invalid && (this.yearControl.touched || this.submitted);
  }

  protected search() {
    this.submitted = true;
    this.monthControl.markAsTouched();
    this.yearControl.markAsTouched();

    if (this.monthControl.invalid || this.yearControl.invalid) {
      return;
    }

    const month = Number(this.monthControl.value);
    const year = Number(this.yearControl.value);

    this.lookup$.next({month, year});
  }

  private handleLookup() {
    const subscription = this.lookup$
      .pipe(
        exhaustMap(({month, year}) =>
          this.http
            .get<PoSignupSchemeItem>(`${environment.api}/po-signup-scheme/${month}/${year}`)
            .pipe(
              catchError((error: HttpErrorResponse) => {
                this.schemeItem = {
                  description: (error.status == 404)
                    ? 'Helaas kunnen we geen informatie vinden voor de opgegeven geboortedatum. Kijk voor meer informatie over aanmelden op de pagina over scholen met een leerlingplafond.'
                    : 'Er is iets misgegaan bij het ophalen van de informatie. Probeer het later opnieuw of kijk voor meer informatie over aanmelden op de pagina over scholen met een leerlingplafond.',
                  informationUrl: '/artikel/aanmelden-bij-een-school-met-leerlingplafond',
                }

                return EMPTY;
              }),
            ),
        ),
      )
      .subscribe(schemaItem => {
        const {description, information_url: informationUrl} = schemaItem;
        this.schemeItem = {description, informationUrl};
      });

    this.subscriptions.push(subscription);
  }
}
